import { Grid, Typography } from "@mui/material";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import CustomTextField from "../../CustomTextField";
import { yupResolver } from "@hookform/resolvers/yup";
import RoundButton from "../../RoundButton";
import { Stack } from "@mui/system";
import { useResponsive } from "../../../hooks/useResponsive";
import { useTranslation } from "react-i18next";
import { useReservationSchema } from "../../../validations/dailyReservationScheme";

const ExtendedReservationForm = (props) => {
  const { extendReservationScheme } = useReservationSchema();

  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
    resolver: yupResolver(extendReservationScheme),
  });

  const lgUp = useResponsive("up", "lg");
  const { t } = useTranslation();

  return (
    <form onSubmit={handleSubmit((data) => props?.handleSubmit(data))}>
      <Grid
        container
        rowSpacing={1}
        sx={{ mt: 2 }}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        <Grid item xs={12}>
          <Controller
            name="numOfDays"
            control={control}
            render={({ field }) => (
              <CustomTextField
                {...field}
                size="small"
                placeholder={t("pages.makeReservation.input03")}
                label={t("pages.makeReservation.input03")}
                name="numOfDays"
                type="number"
                error={!!errors.numOfDays}
                helperText={errors.numOfDays?.message}
                required
              />
            )}
          />
        </Grid>
      </Grid>

      <Stack
        sx={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "90%",
          maxWidth: 900,
          marginBottom: 2,
        }}
        spacing={2}
      >
        <RoundButton
          size="large"
          variant="contained"
          type="submit"
          color="primary"
          rounded
          disabled={!isValid}
        >
          <Typography variant="buttonText" color="common.buttonText">
            {t("commonLabels.text17")}
          </Typography>
        </RoundButton>
      </Stack>
    </form>
  );
};
export default ExtendedReservationForm;
